
import { animate, stagger } from 'animejs';

class Nav {
  constructor() {
    let cache = {};
    let scrollPos = 0;
    let initFunc = () => {
      initCache();
      registerEvents();
      scrollDetect();
    }

    let initCache = () => {
      cache.header = document.querySelector('header');
      cache.nav = cache.header.querySelector('.nav');
      cache.navmobileBtn = cache.header.querySelector('.burger');
      cache.navmobile = cache.header.querySelector('.nav_mobile');
      cache.secTxtWhite = document.querySelectorAll('.nav_white');
      cache.secTxtBlue = document.querySelectorAll('.nav_blue'); 
      cache.animeLogo = cache.navmobile.querySelector('.logo');
    };

    let registerEvents = () => {
      cache.navmobileBtn.addEventListener("click", openNav);
      window.addEventListener('scroll', scrollDetect);
    };

    let openNav = () => {
      cache.navmobileBtn.removeEventListener("click", openNav);
      cache.header.classList.add('open');
      document.querySelector('body').classList.add('overflow');
      document.querySelector('html').classList.add('overflow');
      cache.navmobileBtn.addEventListener("click", closeNav);
      animate(cache.animeLogo.querySelectorAll('svg path'), {
        opacity: [0, 1],
        translateY: ["200%", "0%"],
        ease: 'outSine',
        delay: stagger(50),
        duration: stagger(100, { start: 800 }),
      });
    }

    let closeNav = () => {
      cache.navmobileBtn.removeEventListener("click", closeNav);
      cache.header.classList.remove('open');
      document.querySelector('body').classList.remove('overflow');
      document.querySelector('html').classList.remove('overflow');
      cache.navmobileBtn.addEventListener("click", openNav);
    }

    let scrollDetect = () => {
      let up = false;
      let trigger = 150;
      if(scrollPos > window.pageYOffset) {
        up = true;
      }
      scrollPos = window.pageYOffset;

      if(cache.nav.classList.contains('logo_text')) {
        trigger = 300;
        const logoText = cache.nav.querySelector('.logo_text');
        const logoSvg = cache.nav.querySelector('.logo_svg');

        if(scrollPos > 150 && !cache.nav.classList.contains('logo_text_hidden')) {
          cache.nav.classList.add('logo_text_hidden');
          logoSvg.style.display = 'block';
          animate(logoText, {  
            opacity: [1, 0],
            translateX: ['-50%', '-50%'],
            translateY: ['-50%', '50%'],
            duration: 300,
            ease: 'outSine',
            onComplete: function() {
              logoText.style.display = 'none';
            }
          });
          animate(logoSvg, {  
            opacity: [0, 1],
            translateY: [-20, 0],
            duration: 300,
            delay: 200,
            ease: 'outSine',
          });
        } else if(scrollPos < 150 && cache.nav.classList.contains('logo_text_hidden')) {
          cache.nav.classList.remove('logo_text_hidden');
          logoText.style.display = 'block';
          animate(logoSvg, {  
            opacity: [1, 0],
            translateY: [0, -20],
            duration: 400,
            ease: 'outSine',
            onComplete: function() {
              logoSvg.style.display = 'none';
            }
          });
          animate(logoText, {  
            opacity: [0, 1],
            translateX: ['-50%', '-50%'],
            translateY: ['50%', '-50%'],
            duration: 200,
            ease: 'outSine',
          });
        }
      }


      if(scrollPos > trigger && !up && !cache.header.classList.contains('up') ) {
        cache.header.classList.add('up');
      } else if(scrollPos > trigger && up && cache.header.classList.contains('up') ) {
        cache.header.classList.remove('up');
      }


      for(let i = 0; i < cache.secTxtWhite.length; i++) {
        let section = cache.secTxtWhite[i];
        let top = section.offsetTop;
        let bottom = section.offsetTop + section.offsetHeight;
        if((scrollPos + 60) > top && (scrollPos + 60) < bottom && cache.nav.classList.contains('txt_blue')) {
          cache.nav.classList.remove('txt_blue');
          cache.nav.classList.add('txt_white');
        }
      }

      for(let i = 0; i < cache.secTxtBlue.length; i++) {
        let section = cache.secTxtBlue[i];
        let top = section.offsetTop;
        let bottom = section.offsetTop + section.offsetHeight;
        if( (scrollPos + 60) > top && (scrollPos + 60) < bottom && cache.nav.classList.contains('txt_white')) {
          cache.nav.classList.remove('txt_white');
          cache.nav.classList.add('txt_blue');
        }
      }

    }

    initFunc();
  };
}
export { Nav }
